import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import AttendanceActions, { AttendanceRedux, AttendanceTypes } from '../Redux/AttendanceRedux'
import { notificationFail } from '../Redux/NotificationActions'

const attendanceCrudObservable = createCRUDObservable({
  mainRedux: AttendanceRedux,
  reduxPath: 'attendance',
})

const attendanceByHourExcelEpic = (action$, store, { Api }) =>
  action$.ofType(AttendanceTypes.AttendanceByHourExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.attendance.getAttendanceByHourExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            AttendanceActions.AttendanceByHourExcelSuccess(),
          ]
        })
    ))

const attendanceExcelEpic = (action$, store, { Api }) =>
  action$.ofType(AttendanceTypes.AttendanceExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.attendance.getAttendanceExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            AttendanceActions.AttendanceExcelSuccess(),
          ]
        })
    ))

export const attendanceObservers = Object.assign({}, attendanceCrudObservable.observers, {})

export const attendanceEpic = combineEpics(
  attendanceCrudObservable.epic,
  attendanceByHourExcelEpic,
  attendanceExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/AttendanceObservable.js